<template>
<div class="findpassword" id="">  
  <XR-head titleText="手机重置支付密码" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="手机号" icon=":fa fa-phone" labelFloat fullWidth :disabled="true" v-model="mobile" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="70" tablet="75" desktop="33">
      <mu-text-field label="短信验证码" helpText="点击右侧按钮获取" v-model="resetInfo.smsCode" icon=":fa fa-envelope-o" labelFloat fullWidth />
    </mu-col>
    <mu-col width="30" tablet="25" desktop="33">      
      <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="新密码" type="password" icon=":fa fa-lock" labelFloat fullWidth v-model="resetInfo.newPayPassword" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="确认密码" type="password" icon=":fa fa-lock" labelFloat fullWidth v-model="resetInfo.confrimNewPayPassword" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="下一步" class="demo-raised-button" primary fullWidth @click="submit()" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      mobile:'',
      isSms:false,
      resetInfo:{
        smsCode:'',
        newPayPassword:'',
        confrimNewPayPassword:''
      },
      smsBtnText : '获取短信'
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.mobile=res.Data.mobile
        }
      });      
    },
    submit: function () {
      var ths = this;   
      if(!ths.resetInfo.smsCode){
          ths.$refs.XRtoast.failed("请输入验证码", true)
        return
      }
      if(!ths.resetInfo.newPayPassword){
          ths.$refs.XRtoast.failed("请输入新支付密码", true)
        return
      }
      if(!ths.resetInfo.confrimNewPayPassword){
          ths.$refs.XRtoast.failed("请输入确认支付密码", true)
        return
      }
      if(ths.resetInfo.newPayPassword != ths.resetInfo.confrimNewPayPassword){
          ths.$refs.XRtoast.failed("二次输入的密码不一样", true)
        return
      }

      ths.$post(
        "/Shop/UserServer/MobileResetPayPassword",
        JSON.stringify(this.resetInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId==1){
            ths.resetInfo.smsCode = ''
          }
          ths.resetInfo.newPayPassword = ''
          ths.resetInfo.confrimNewPayPassword = ''
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{ 
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
      if(!ths.isSms){
        ths.$post(
          "/Shop/UserServer/MobileResetPayPasswordSendSms"
        ).then(function(res) {
          ths.$refs.XRtoast.hide()
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{    
            ths.isSms = true      
            ths.smsBtnText = res.Data * 60;
            var interval = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
                ths.isSms = true    
              }else{
                ths.isSms = false    
                ths.smsBtnText = '获取短信'
                clearInterval(interval)
              }
            }, 1000)  
          }
        });
      }
    },
    goBack(){
      this.$router.go(-2)
    }
  }
}

</script>
<style>
.findpassword{
  background: white;
}
.findpassword .login-form {
  padding: 10px 20px 20px 10px;
}
.findpassword .login-div {
  padding: 40px 0px 0 20px;
}
.findpassword .demo-raised-button {
  height: 50px;
}
.findpassword .div2 {
  padding: 20px 0 0 0;
}
.findpassword .demo-flat-button.right {
  float: right;
}
.findpassword .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.findpassword .findpassword .notice{
  font-size: 12px;
}
.findpassword .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/paypasswordReset.vue